import { MeshBuilder, StandardMaterial, Color3, Vector3, PointLight } from "@babylonjs/core";
import { RoomDecorations } from "./RoomDecorations.js";

// Gère uniquement le sol et les matériaux de base des plateformes.

export class RoomVisuals {
    static createPlatforms(manager, platforms, config) {
        platforms.forEach(pos => {
            // Créer une plateforme plus épaisse pour un style industriel brut
            // Largeur légèrement augmentée pour éviter les problèmes de collisions/gaps aux extrémités
            const p = MeshBuilder.CreateBox("p", { width: 4.05, height: 0.5, depth: 4.05 }, manager.scene);
            p.position = pos.clone();
            p.position.y -= 0.25; // Ajuster pour que le haut soit à y=0

            const mat = new StandardMaterial("pMat", manager.scene);
            // Couleurs plus claires pour améliorer la visibilité de la carte
            mat.diffuseColor = new Color3(0.15, 0.15, 0.2);
            mat.specularColor = new Color3(0.3, 0.3, 0.4);

            // Éclairage plus prononcé basé sur la config
            mat.emissiveColor = config ? config.color.scale(0.3) : new Color3(0.2, 0.1, 0.3);
            p.material = mat;

            // Ajout d'une bordure "néon" pour le côté esthétique
            const edge = MeshBuilder.CreatePlane("edge", { width: 3.9, height: 3.9 }, manager.scene);
            edge.rotation.x = Math.PI / 2;
            edge.position = pos.clone();
            edge.position.y += 0.01; // Juste au-dessus de la plateforme
            const edgeMat = new StandardMaterial("edgeMat", manager.scene);
            edgeMat.emissiveColor = config ? config.color : new Color3(0.5, 0.2, 0.8);
            edgeMat.wireframe = true;
            edgeMat.alpha = 0.8;
            edge.material = edgeMat;
            edge.isPickable = false;

            manager.envNodes.push(p);
            manager.envNodes.push(edge);

            // Décorations désactivées

        });
    }
}